<template>
  <v-card tile>
    <v-card-title class="pl-0">
      <v-icon color="cyan" class="mdi-rotate-90" large>mdi-window-minimize</v-icon>我的消息
    </v-card-title>
    <v-card-text>
      <v-row class="mt-2 mb-6">
        <v-btn class="ml-8" color="primary" :text="queryParam.type!=null" @click="onSearch()">全部</v-btn>
        <v-btn class="ml-4" color="primary" :text="queryParam.type!=1" @click="onSearch(1)">已读</v-btn>
        <v-btn class="ml-4" color="primary" :text="queryParam.type!=0" @click="onSearch(0)">未读</v-btn>
        <v-spacer />
        <v-text-field dense rounded hide-details label="搜索关键词" single-line v-model="queryParam.searchValue" outlined prepend-inner-icon="mdi-magnify" @keydown.native="onSearchValueKeydown" />
      </v-row>
      <v-data-table dense :headers="headers" :items="dataList" hide-default-footer disable-sort>
        <template v-slot:item.sn="{ item }">{{dataList.indexOf(item)+1}}</template>
        <template v-slot:item.ct="{ item }">{{ Utility.fmtDt(item.ct) }}</template>
        <template v-slot:item.title="{ item,value }">
          <span v-if="item.newVersionFlag == '1'" style="cursor:pointer" @click="openWindow(item)">{{value}}</span>
          <router-link v-else-if="item.readFlag" class="grey--text text-decoration-none" :to="item.url">{{value}}</router-link>
          <router-link v-else class="text-decoration-none" :to="item.url">{{value}}</router-link>
        </template>
        <template v-slot:item.readFlag="{ item }">{{ item.readFlag?'已读':'未读' }}</template>
      </v-data-table>
      <v-pagination v-if="pagination.num>1" v-model="pagination.index" :length="pagination.num" :total-visible="pagination.size" @input="onPage" />
    </v-card-text>

  </v-card>
</template>
<script>
/* eslint-disable no-console */
import { queryUserMessage } from '@/plugins/api';
export default {
  data () {
    return {
      headers: [
        { text: '#', value: 'sn' },
        { text: '标题', value: 'title' },
        { text: '时间', value: 'ct' },
        { text: '状态', value: 'readFlag' },
      ],
      dataList: [],
      pagination: { index: 1, size: 10, num: 0, total: 0 },
      queryParam: { searchValue: '' },
    }
  },
  created () {
    this.onSearch()
  },
  methods: {
    dataQuery (param) {
      queryUserMessage(param).then(res => {
        this.dataList = res.data;
        this.pagination = res.pagination;
      })
    },
    onPage () {
      let param = { ...this.queryParam, pagination: { index: this.pagination.index, size: this.pagination.size } }
      this.dataQuery(param);
    },
    onSearch (type) {
      this.queryParam.type = type
      let param = { ...this.queryParam, pagination: { index: 1, size: this.pagination.size } }
      this.dataQuery(param);
    },
    openWindow(item) {
      window.open(item.url, '_blank')
    },

    onSearchValueKeydown (e) {
      if (e.keyCode == 13) this.onSearch(this.queryParam.type)
    }
  }
}
</script>